export default function() {
  const styles1 = [
    'display: block; color: #fff; background: red; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: orange; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: gold; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: yellowgreen; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: skyblue; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: steelblue; font-size: 12px; line-height: 0.9; padding: 5px;',
    'display: block; color: #fff; background: darkviolet; font-size: 12px; line-height: 0.9; padding: 5px;',
  ]
  const styles2 = [
    'display: block; color: #fff; background: red; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: orange; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: gold; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: yellowgreen; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: skyblue; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: steelblue; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
    'display: block; color: #fff; background: darkviolet; font-size: 16px; padding: 10px; line-height: 0.9; margin: 0px',
  ]

  console.log(
    `%cm%ca%cd%ce%c %cw%ci%ct%ch%c♥`,
    styles1[2],
    styles1[6],
    styles1[4],
    styles1[3],
    styles1[1],
    styles1[6],
    styles1[2],
    styles1[4],
    styles1[5],
    styles1[0]
  )
  console.log(
    `%cO%cA%cK%cS%c %cL%cA%cN%cE`,
    styles2[0],
    styles2[1],
    styles2[2],
    styles2[3],
    styles2[4],
    styles2[5],
    styles2[6],
    styles2[0],
    styles2[1]
  )
}
